module.exports = __webpack_public_path__ + "img/5.2-设备维护成本高.f118fbf5.png";